import { render, staticRenderFns } from "./AffiliatesAgentReport.vue?vue&type=template&id=2a61d54e&"
import script from "./AffiliatesAgentReport.vue?vue&type=script&lang=ts&"
export * from "./AffiliatesAgentReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports